import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import startCase from 'lodash/startCase';
import { useGameLineSelectionsIds } from '~SpectateStore/hooks/selectionsHooks';
import { useSportSlugByEventId } from '~SpectateStore/hooks/sportsHooks';
import {
    useShowTeamLogo,
    useShowAwayJersey,
} from '~SpectateStore/hooks/tournamentsHooks';
import { useCategorySlugByEventId } from '~SpectateStore/hooks/categoriesHooks';
import {
    useHomeTeamSlug,
    useAwayTeamSlug,
} from '~SpectateStore/hooks/eventsHooks';
import { THREE_MARKET_HEADERS } from '~shared/utils/constants';
import { getTeamLogoUrl } from '~shared/utils/sportsbook';
import CellSelectionLine from './CellSelectionLine';
import './styles/gridColumns.scss';

const SelectionsGridGameLine = ({ eventId, marketId }) => {
    const [ t ] = useTranslation();
    const sportSlug = useSportSlugByEventId(eventId);
    const headers = THREE_MARKET_HEADERS[sportSlug];
    const selectionsIds = useGameLineSelectionsIds(eventId, marketId, headers);
    const showTeamLogo = useShowTeamLogo(eventId);
    const showAwayJersey = useShowAwayJersey(eventId);
    const categorySlug = useCategorySlugByEventId(eventId);
    const homeSlug = useHomeTeamSlug(eventId);
    const awaySlug = useAwayTeamSlug(eventId);

    return (
        <>
            <div className="selections-col-grid selections-col-grid__header-section">
            {
                headers.map(header => {
                    return (
                        <div
                            key={header}
                            className="selections-col-grid__headers"
                        >
                            {startCase(t(`mkt_headers.${header}`))}
                        </div>
                    );
                })
            }
            </div>
            <div className="selections-col-grid">
                {
                    Object.keys(selectionsIds).map((line, idx) => {

                        const competitorSlug = idx === 0 ? awaySlug : homeSlug;
                        const shouldShowAwayJersey = (idx === 0) && showAwayJersey;
                        const teamLogo = showTeamLogo ? getTeamLogoUrl(sportSlug, categorySlug, competitorSlug, shouldShowAwayJersey) : null;

                        return <CellSelectionLine
                            key={line}
                            ids={selectionsIds[line]}
                            label={line}
                            headers={headers}
                            showSelectionLabels
                            teamLogo={teamLogo}
                        />;
                    }
                    )
                }
            </div>
        </>
    );
};

SelectionsGridGameLine.propTypes = {
    eventId: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired,
    ]),
    marketId: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired,
    ]),
    headers: PropTypes.array,
};

export default SelectionsGridGameLine;
